<template lang="pug">
  .app(:class="{'no-home': !isHome, 'is-home': isHome}")
    .cre(v-if="showPopup === true")
      a.cre-bg(href="#", @click.prevent="close" title="Fermer la popup")
      .cre-img
        a.cre-close(href="#", @click.prevent="close" title="Fermer la popup"): span &cross;
        a(href="/static/chequeRelanceExport.pdf", target="_blank" title="Afficher le PDF")
          img(src="/static/chequeRelanceExport.jpg", alt="Chèque relance export")
    vnav
    .main
      router-view
</template>

<script>

import Nav from './components/Nav'
import Menu from './store/Menu'

export default {
  data () {
    return {
      Menu,
      isHome: false,
      showPopup: true
    }
  },
  components: {
    vnav: Nav
  },
  beforeMount () {
    this.isHome = this.$route.name === 'Home'
    this.$i18n.i18next.changeLanguage(this.$route.params.lang)
    this.showPopup = window.localStorage.getItem('popup') || true
    window.localStorage.setItem('popup', false)
  },
  beforeUpdate () {
    this.isHome = this.$route.name === 'Home'
    this.$i18n.i18next.changeLanguage(this.$route.params.lang)
  },
  methods: {
    close (e) {
      this.showPopup = false
    },
    redirect (lang) {
      let params = this.$route.params
      params.lang = lang
      this.$router.push({name: this.$route.name, params})
    }
  }
}
</script>

<style lang="scss">

@import "./scss/mixin";
@import "./scss/config";
@import "./scss/reset";
@import "./scss/fonts";
@import "./scss/rules";


.app {
  z-index: 10;

  &.is-home {
    padding-top: $menuTopSize;
  }

  @include bp(xs) {
    padding-top: $menuTopSize;
  }

  .cre {

    &-bg {
      z-index: 9999;
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: black;
      opacity: 0.5;
    }

    &-img {
      z-index: 10000;
      display: block;
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      img {
        max-width: 90vw;
      }
    }

    &-close {
      z-index: 10001;
      text-decoration: none;
      border-radius: 100%;
      display: block;
      position: fixed;
      font-size: 30px;
      right: -19px;
      top: -19px;
      color: $valencia;
      border: 2px solid $donJuan;
      background-color: $ebb;
      padding: 8px 10px;
    }
  }

  .header {
    background-color: $donJuan;

    .logo {
      height: 70px;
      margin: 15px;
    }

    a {
      display: inline-block;
      font-size: 2.5rem;
      color: white;
      padding: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?71d7e8f3